document.addEventListener('DOMContentLoaded', function() {
  new Swiper('.collection-carousel-swiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      900: {
        slidesPerView: 2,
        spaceBetween: 20
      }
    }
  });
}); 